// import React, { useState } from 'react';
// import axios from 'axios';
// import { apiurl } from '../config/config';
// import { Link } from 'react-router-dom';

// const SearchModal = () => {
//   const [showModal, setShowModal] = useState(false);
//   const [query, setQuery] = useState('');
//   const [applications, setApplications] = useState([]);
//   const [employees, setEmployees] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const handleSearch = async () => {
//     if (!query.trim()) return;
//     setLoading(true);
//     try {
//       const response = await axios.get(`${apiurl}/utils/unified-search?q=${query}`);
//       setApplications(response.data.applications || []);
//       setEmployees(response.data.employees || []);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       {/* Trigger */}
//       <input
//         type="text"
//         placeholder="Click to Search"
//         className="border p-2 rounded w-full cursor-pointer"
//         onFocus={() => setShowModal(true)}
//         readOnly
//       />

//       {/* Modal */}
//       {showModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
//           <div className="bg-white p-6 rounded-lg w-full max-w-2xl shadow-lg relative">
//             <button
//               className="absolute top-2 right-2 text-gray-500 hover:text-black"
//               onClick={() => setShowModal(false)}
//             >
//               ✖
//             </button>

//             <h2 className="text-xl font-semibold mb-4">Search</h2>

//             <div className="flex gap-2">
//               <input
//                 type="text"
//                 className="border p-2 w-full rounded"
//                 placeholder="Search applications or employees"
//                 value={query}
//                 onChange={(e) => setQuery(e.target.value)}
//               />
//               <button
//                 onClick={handleSearch}
//                 className="bg-blue-600 text-white px-4 py-2 rounded"
//               >
//                 Search
//               </button>
//             </div>

//             <div className="mt-4 max-h-64 overflow-y-auto space-y-4">
//               {loading ? (
//                 <p className="text-blue-500">Loading...</p>
//               ) : (
//                 <>
//                   {/* Applications */}
//                   {applications.length > 0 && (
//                     <div>
//                       <h3 className="font-semibold">Applications</h3>
//                       <ul className="bg-gray-100 p-2 rounded">
//                         {applications.map((app) => (
//                           <li key={app._id} className="py-1 border-b last:border-b-0">
//                             <Link to={`/applications/${app._id}/manage`} className="text-blue-600 hover:underline">
//                               {app.candidateSnapshot.firstName + ' ' + app.candidateSnapshot.lastName + ' - ' + app.applicationStatus}
//                             </Link>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   )}

//                   {/* Employees */}
//                   {employees.length > 0 && (
//                     <div>
//                       <h3 className="font-semibold">Employees</h3>
//                       <ul className="bg-gray-100 p-2 rounded">
//                         {employees.map((emp) => (
//                           <li key={emp._id} className="py-1 border-b last:border-b-0">
//                             <Link to={`/employees/${emp._id}/manage`} className="text-blue-600 hover:underline">
//                               {emp.personalDetails?.firstName + ' ' + emp.personalDetails?.lastName + ' - ' + emp.employeeCode}
//                             </Link>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   )}

//                   {/* No Results */}
//                   {applications.length === 0 && employees.length === 0 && (
//                     <p className="text-gray-500">No results found.</p>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchModal;

import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { apiurl } from "../config/config";
import { Link } from "react-router-dom";
import { IoSearch } from "react-icons/io5";

const SearchModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [query, setQuery] = useState("");
  const [applications, setApplications] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    if (showModal && inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 100);
    }
  }, [showModal]);

  const handleSearch = async () => {
    if (!query.trim()) return;
    setLoading(true);
    try {
      const response = await axios.get(`${apiurl}/utils/unified-search?q=${query}`);
      setApplications(response.data.applications || []);
      setEmployees(response.data.employees || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Trigger */}
      <input
        type="text"
        placeholder="Click to Search"
        className="border p-2 rounded w-full cursor-pointer hidden md:block"
        onFocus={() => setShowModal(true)}
        readOnly
      />

{/* <div className="md:hidden bg-zinc-100 w-8 h-8 lg:w-10 lg:h-10 border rounded-full relative flex items-center justify-center">
  <IoSearch className="" />
</div> */}

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white p-6 rounded-2xl w-full max-w-2xl shadow-xl relative">
            {/* Close */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl"
              onClick={() => setShowModal(false)}
            >
              ✖
            </button>

            {/* Title */}
            <h2 className="text-2xl font-bold mb-4 text-gray-800">🔍 Search</h2>

            {/* Input */}
            <div className="flex gap-2">
              <input
                ref={inputRef}
                type="text"
                className="border p-3 w-full rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                placeholder="Search applications or employees..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              />
              <button
                onClick={handleSearch}
                className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg transition"
              >
                Search
              </button>
            </div>

            {/* Results */}
            <div className="mt-6 max-h-72 overflow-y-auto space-y-6">
              {loading ? (
                <p className="text-blue-500">Loading...</p>
              ) : (
                <>
                  {/* Applications */}
                  {applications.length > 0 && (
                    <div>
                      <h3 className="font-semibold text-lg border-b pb-1 mb-2 text-gray-700">
                        Applications
                      </h3>
                      <div className="space-y-2">
                        {applications.map((app) => (
                          <Link
                            key={app._id}
                            to={`/applications/${app._id}/manage`}
                            className="block bg-gray-50 p-3 rounded-lg hover:bg-blue-50 shadow-sm transition"
                          >
                            <p className="font-medium text-gray-900">
                              {app.candidateSnapshot.firstName}{" "}
                              {app.candidateSnapshot.lastName}
                            </p>
                            <p className="text-sm text-gray-600">
                              Status: {app.applicationStatus}
                            </p>
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Employees */}
                  {employees.length > 0 && (
                    <div>
                      <h3 className="font-semibold text-lg border-b pb-1 mb-2 text-gray-700">
                        Employees
                      </h3>
                      <div className="space-y-2">
                        {employees.map((emp) => (
                          <Link
                            key={emp._id}
                            to={`/employees/${emp._id}/manage`}
                            className="block bg-gray-50 p-3 rounded-lg hover:bg-green-50 shadow-sm transition"
                          >
                            <p className="font-medium text-gray-900">
                              {emp.personalDetails?.firstName}{" "}
                              {emp.personalDetails?.lastName}
                            </p>
                            <p className="text-sm text-gray-600">
                              Employee Code: {emp.employeeCode}
                            </p>
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* No Results */}
                  {applications.length === 0 && employees.length === 0 && query && (
                    <p className="text-gray-500 text-center">No results found.</p>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchModal;